export default __webpack_public_path__ + "static/media/icon_warning.133e0109.svg";